import React, { useContext } from 'react';
import { makeStyles, Typography } from '@material-ui/core';
import { DealerContext } from '../shared/contexts/DealerContext';

const useStyles = makeStyles(() => ({
  root: {
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    padding: '0px 15px 75px 15px',
    '@media (max-width: 500px)': {
      display: 'block',
    },
  },
  inner: {
    maxWidth: '1170px',
  },
  Intro: {
    fontSize: '28px',
    fontWeight: 'bold',

    margin: '20px 0px',
  },
  HeadingIntro: {
    fontSize: '28px',
    fontWeight: 'bold',
    textAlign: 'center',
    margin: '10px 0px',
  },
  textIntro: {
    fontSize: '14px',
    padding: '10px 0px',
    marginBottom: '0px',
    display: 'block',
    textAlign: 'justify',
    minHeight: '100px',
  },
  section: {
    width: '100%', // Default for mobile and small tablets
    paddingRight: '15px',
    '@media (min-width: 769px)': {
      width: '50%', // Apply 50% only on wider screens (≥ 769px)
    },
  },

  sectionHolder: {
    display: 'block',
    width: '100%', // Default for mobile (≤ 500px)
    '@media (min-width: 501px)': {
      display: 'flex',
    },
    '@media (min-width:501px) and (max-width: 768px)': {
      flexDirection: 'column',
    },
  },

  listFlex: {
    display: 'flex',
    justifyContent: 'center',
    padding: '0px 40px',
    '@media (max-width: 500px)': {
      flexDirection: 'column',
      padding: '20px',
    },
    '@media (min-width:501px) and (max-width: 768px)': {
      flexDirection: 'column',
      padding: '20px',
    },
  },
  list: {
    width: '24%',
    textAlign: 'left',
    '@media (max-width: 500px)': {
      width: '100%',
    },
  },
  img: {
    height: '100%',
    maxHeight: '160px',
    transition: '0.5s ease all',
    margin: '20px 0px',
    '&:hover': {
      cursor: 'pointer',
      transform: 'scale(1.1)',
    },
  },
  imgHolder: {
    overflow: 'hidden',
  },
  titleTopAccent: {
    fontSize: '44px',
    color: ({ websiteColors }) => `${websiteColors.accentColor}`,
    fontWeight: 'bold',
    textAlign: 'center',
    paddingBottom: '25px',
  },
}));

const AboutUs = () => {
  const { websiteColors } = useContext(DealerContext);
  const classes = useStyles({ websiteColors });

  return (
    <div className={classes.root}>
      <div className={classes.inner}>
        <Typography variant="h1" className={classes.titleTopAccent}>
          About Us
        </Typography>
        <Typography variant="h2" className={classes.HeadingIntro}>
          MEKOR Group History
        </Typography>
        <Typography variant="body1" className={classes.textIntro}>
          Privately Owned. Proudly Cape-Based. Established in 2000.
          <br />
          <br />
          MEKOR Motors Group started its journey in 2000 as an exclusive HONDA dealership, aligning
          with the launch of HONDA Motor Southern Africa. Rapid growth followed, and at its peak,
          MEKOR held nearly a third of HONDA automobile sales nationally, with operations spanning
          the Western Cape, Gauteng, and KwaZulu-Natal.
          <br />
          <br />
          As the business matured, our Cape Town-based shareholders made a deliberate decision to
          focus solely on the Western Cape — ensuring hands-on leadership, consistent quality, and
          meaningful community involvement.
          <br />
          <br />
          Today, MEKOR represents{' '}
          <span style={{ fontWeight: 'bold' }}>
            10 leading automotive brands across 12 conveniently located dealerships,
          </span>{' '}
          from <span style={{ fontWeight: 'bold' }}>Constantia</span> in the south to{' '}
          <span style={{ fontWeight: 'bold' }}>Cape Gate</span> in the north. We are a trusted name
          in mobility — offering cars, motorcycles, electric vehicles, and pre-owned solutions
          backed by expert care.
        </Typography>
        <hr />
        <Typography variant="h2" className={classes.HeadingIntro}>
          Our Dealerships & Brands
        </Typography>
        <div className={classes.sectionHolder}>
          <div className={classes.section}>
            <Typography variant="body1" className={classes.textIntro}>
              <span style={{ fontWeight: 'bold' }}>HONDA Automobiles</span>
              <ul>
                <li>
                  <span style={{ fontWeight: 'bold' }}>Cape Town City</span> – 20 Christiaan Barnard
                  Street
                </li>
                <li>
                  <span style={{ fontWeight: 'bold' }}>Canal Walk</span> – POD 2, Canal Walk
                  Shopping Centre (Open 7 days/week)
                </li>
                <li>
                  <span style={{ fontWeight: 'bold' }}>Tygerberg</span> – 3 High Street, Rosenpark
                </li>
                <li>
                  <span style={{ fontWeight: 'bold' }}>Claremont</span> – Old Stanhope Road
                </li>
                <li>
                  <span style={{ fontWeight: 'bold' }}>Constantiaberg</span> – 155 Main Road, Diep
                  River (Pre-Owned Collection)
                </li>
              </ul>
            </Typography>
            <hr />
            <Typography variant="body1" className={classes.textIntro}>
              <span style={{ fontWeight: 'bold' }}>HONDA Motorcycles</span>
              <ul>
                <li>
                  <span style={{ fontWeight: 'bold' }}>Adventure Centre</span> – High Street,
                  Rosenpark
                </li>
                <li>
                  <span style={{ fontWeight: 'bold' }}>Cape Town City</span> – Just off Christiaan
                  Barnard Street
                </li>
              </ul>
            </Typography>
            <hr />
            <Typography variant="body1" className={classes.textIntro}>
              <span style={{ fontWeight: 'bold' }}>MAZDA (est. 2014)</span>
              <ul>
                <li>
                  <span style={{ fontWeight: 'bold' }}>Tygervalley</span> – High Street, Rosenpark
                </li>
                <li>
                  <span style={{ fontWeight: 'bold' }}>Claremont</span> – Old Stanhope Road
                </li>
              </ul>
            </Typography>
            <hr />
            <Typography variant="body1" className={classes.textIntro}>
              <span style={{ fontWeight: 'bold' }}>OMODA & JAECOO (est. 2023)</span>
              <ul>
                <li>
                  <span style={{ fontWeight: 'bold' }}>5 High Street, Rosenpark</span> – Just off
                  Durban Road
                </li>
              </ul>
            </Typography>
          </div>
          <div className={classes.section}>
            <Typography variant="body1" className={classes.textIntro}>
              <span style={{ fontWeight: 'bold' }}>SUZUKI (est. 2014)</span>
              <ul>
                <li>
                  <span style={{ fontWeight: 'bold' }}>Tygervalley</span> – High Street, Rosenpark
                </li>
                <li>
                  <span style={{ fontWeight: 'bold' }}>Kenilworth</span> – Adjacent to Kenilworth
                  Centre
                </li>
                <li>
                  <span style={{ fontWeight: 'bold' }}>Constantiaberg</span> – Main Road, Diep River
                </li>
                <li>
                  <span style={{ fontWeight: 'bold' }}>Cape Gate</span> – Retail boutique inside
                  Cape Gate Shopping Centre & full dealership on the northern side (Open 7
                  days/week)
                </li>
              </ul>
            </Typography>
            <hr />
            <Typography variant="body1" className={classes.textIntro}>
              <span style={{ fontWeight: 'bold' }}>BYD – Build Your Dreams (est. 2023)</span>
              <ul>
                <li>
                  <span style={{ fontWeight: 'bold' }}>Cape Town City</span> – 20 Christiaan Barnard
                  Street, Foreshore
                </li>
                <li>
                  <span style={{ fontWeight: 'bold' }}>Tygervalley</span> – Opened May 2025,
                  Rosenpark
                </li>
              </ul>
            </Typography>
            <hr />
            <Typography variant="body1" className={classes.textIntro}>
              <span style={{ fontWeight: 'bold' }}>MG – Morris Garages</span>
              <ul>
                <li>
                  <span style={{ fontWeight: 'bold' }}>Cape Town City</span> – Opened January 2025
                </li>
              </ul>
              <br />
            </Typography>
            <hr />
            <Typography variant="body1" className={classes.textIntro}>
              <span style={{ fontWeight: 'bold' }}>BAIC & JAC (est. 2023)</span>
              <ul>
                <li>
                  <span style={{ fontWeight: 'bold' }}>Canal Walk Shopping Centre</span> – Open 7
                  days/week
                </li>
              </ul>
            </Typography>
          </div>
        </div>
        <hr />
        <Typography variant="h2" className={classes.HeadingIntro}>
          Pre-Owned & Trade-Ins
        </Typography>
        <Typography variant="body1" className={classes.textIntro}>
          Looking to sell your vehicle? Visit:{' '}
          <a href="https://www.selltomekor.co.za/">selltomekor.co.za/</a>
          <br /> We offer a wide selection of quality pre-owned vehicles at:
          <ul>
            <li>
              <span style={{ fontWeight: 'bold' }}>MEKOR Canal Walk</span> - Pod 2 (Open 7
              days/week)
            </li>
            <li>
              <span style={{ fontWeight: 'bold' }}>MEKOR Constantiaberg</span> - 155 Main Road, Diep
              River
            </li>
          </ul>
        </Typography>
        <hr />
        <Typography variant="h2" className={classes.HeadingIntro}>
          Why Choose MEKOR?
        </Typography>
        <Typography variant="body1" className={classes.textIntro}>
          We&apos;re not just about vehicles — we’re about people, trust, and long-term
          relationships. We are:
          <li>A proud employer of 250+ staff</li>
          <li>Representing 10 respected automotive brands</li>
          <li>Based at 12 customer-friendly locations</li>
          <li>Privately managed, with leadership involved daily</li>
          <li>Trusted by clients, financial institutions, and fleet providers alike</li>
          <br />
          Whether you&apos;re shopping, trading, servicing or simply exploring your options, MEKOR
          is here to make the journey easier — and a little more exciting.
        </Typography>
        <hr />
        <Typography variant="body1" className={classes.textIntro}>
          <span style={{ fontWeight: 'bold' }}>For more information, contact:</span> <br />
          <a href="mailto:debbieh@mekor.co.za">📧 debbieh@mekor.co.za</a>
          <br />
          <a href="https://www.mekor.co.za/">🌐 www.mekor.co.za</a>
        </Typography>
      </div>
    </div>
  );
};

export default AboutUs;
